import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadFilesService {
  baserApiUrl:string=environment.baseApi
  constructor(public http:HttpClient) { }

  
  uploadFile(data:any){
    return this.http.post(`${this.baserApiUrl}upload`,data)
  }

  uploadFilePagos(data:any){
    return this.http.post(`${this.baserApiUrl}upload/pagos`,data)
  }

  uploadFilePaleta(data:any){
    return this.http.post(`${this.baserApiUrl}upload/paleta`,data)
  }

  uploadFileTelefonos(data:any){
    return this.http.post(`${this.baserApiUrl}upload/telefonos`,data)
  }

  uploadFileDatosRecaudo(data:any){
    return this.http.post(`${this.baserApiUrl}upload/datos-recaudo`,data)
  }

  uploadFileEmailMasivo(data:any){
    return this.http.post(`${this.baserApiUrl}upload/mail-masivo`,data)
  }

  uploadFileAcuerdoHistorico(data:any){
    return this.http.post(`${this.baserApiUrl}upload/acuerdos-historicos`,data)
  }

  uploadFileGestionHistorica(data:any){
    return this.http.post(`${this.baserApiUrl}upload/gestion-historica`,data)
  }
}
